/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

const { initialAuthUserFromCookie } = require('./src/utils/sso');

exports.onClientEntry = () => {
  const auth = initialAuthUserFromCookie();
  if (auth && window.analytics) {
    const { email } = auth;
    window.analytics.identify(email, { email });
  }
};
